
define('text!modules/file_upload/upload_template.html',[],function () { return '<div id="<%- id %>" class="dropzone file-upload"></div>\r\n<ul class="list files-list js-upload-files-list"></ul>\r\n';});

